import React from 'react'
import CheckHotlinePage from "./CheckHotlinePage"

function CheckHotlineContainer(props) {
    return (
        <div className="CheckHotlineContainer">
            <CheckHotlinePage/>
        </div>
    )
}

export default CheckHotlineContainer